import * as React from 'react';
import { printAsciiCIText } from '@devsisters/console-easter-egg';

export function useEasterEgg(extraMessages: string[] = []) {
  React.useEffect(() => {
    printAsciiCIText(extraMessages);
  }, []);
}
